import axios from "axios";
import { getTokenHeader } from "@/helpers/commonHelper";
const env = require(`@/environments/${process.env.VUE_APP_ENV_PATH}`);

export const defaultOpLoc = {
  address: {},
  geo: {
    coordinates: ["", ""]
  },
  type: []
};

export async function createOpLoc(opLoc) {
  const headers = getTokenHeader();
  return await axios.post(`${env.events_api_client_url}oploc`, opLoc, {
    headers,
    params: { principal_id: this.selectedPrincipal.id }
  });
}

export async function updateOpLoc(opLoc) {
  const headers = getTokenHeader();
  return await axios.put(`${env.events_api_client_url}oploc`, opLoc, {
    headers,
    params: { principal_id: this.selectedPrincipal.id }
  });
}

export async function deleteOpLoc(opLocId) {
  const headers = getTokenHeader();
  return await axios.delete(`${env.events_api_client_url}oploc/${opLocId}`, {
    headers,
    params: { principal_id: this.selectedPrincipal.id }
  });
}
